var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"abouindex"},[_vm._v("564aaaa365")])
}
var staticRenderFns = []

export { render, staticRenderFns }